// Loader.js
import React from 'react';
import './Loader.scss';

const Loader = () => {
    return (
      /* From Uiverse.io by vinodjangid07 */ 
<div class="loader">
  <div class="panWrapper">
    <div class="pan">
      <div class="food"></div>
      <div class="panBase"></div>
      <div class="panHandle"></div>
    </div>
    <div class="panShadow"></div>
  </div>
</div>

    );
}

export default Loader;
